import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { PostHogProvider } from 'posthog-js/react';
const options = {
  api_host: 'https://us.i.posthog.com',
  defaults: '2025-05-24'
};
render(<PostHogProvider apiKey="phc_yMiI23HF44iIQFeVdKrF4EpIDpQWBNvIToz2Fw6pgqH" options={options} data-id="element-231">
    <App data-id="element-232" />
  </PostHogProvider>, document.getElementById('root'));